import React from 'react';
import { NextcaddyLogo } from '@slope/uikit';
import styled from 'styled-components';
import { TemperatureMin, TemperatureMax, WindyStrong } from '@carbon/icons-react';
import { useWeather } from '../../hooks';

export type BannerProps = {
  children?: React.ReactNode;
};

const TempLabel = styled.div`
  font-size: 1.5rem;
`;

const TemperatureWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
`;

const WindWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
`;

const Flex = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 2rem;
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  padding: 2rem;
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.5);
  border-radius: 16px;
  margin: 1rem;

  @media (max-width: 768px) {
    & {
      flex-direction: column;
      margin: 0;
      gap: 1rem;
      padding: 1rem;
      border-radius: 0;
    }
  }
`;

export const Banner: React.FC<BannerProps> = () => {
  const weatherData = useWeather();

  return (
    <Container>
      <NextcaddyLogo animated />
      <Flex>
        <TemperatureWrapper>
          <TempLabel>{weatherData.temperatureMin}º</TempLabel>
          <TemperatureMin size={30} />
        </TemperatureWrapper>
        <TemperatureWrapper>
          <TempLabel>{weatherData.temperatureMax}º</TempLabel>
          <TemperatureMax size={30} />
        </TemperatureWrapper>
        <WindWrapper>
          <weatherData.WindDirectionIcon size={30} />
          <TempLabel>{weatherData.windSpeedMs.toFixed(2)}m/s</TempLabel>
          <WindyStrong size={30} />
        </WindWrapper>
      </Flex>
    </Container>
  );
};
